/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021-2023 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { createReducer } from '@reduxjs/toolkit';
import DashboardError from './DashboardError';
import { ErrorAction } from './ErrorsActions';

interface IErrorsStore {
  lastErrors: DashboardError[];
}

const initialState: IErrorsStore = {
  lastErrors: [],
};

const ErrorsReducer = createReducer<IErrorsStore>(initialState, (builder) => {
  builder.addCase(ErrorAction.Error, (state, action) => {
    const error = new DashboardError(action.payload);
    error.logToConsole();
    const lastErrors = [...state.lastErrors];
    lastErrors.push(error);
    // Limit lastErrors to 100 (oldest ones get removed)
    lastErrors.splice(0, lastErrors.length - 100);
    return {
      ...state,
      lastErrors,
    };
  });
});

export default ErrorsReducer;
